import cx from 'classnames';
import type { FunctionComponent } from 'react';

import { defineSlotComponent, findAllForSlot } from '../../layouts/slots';

import Tab from './Tab';
import type { TabProps } from './Tab';

import styles from './Tabs.module.less';

type TabsProps = {
  marginBottom?: 'small' | 'medium' | 'large';
};

type TabsComponent = FunctionComponent<TabsProps> & {
  Tab: FunctionComponent<TabProps>;
};

/**
 * Tabs are a set of "dumb" tab components.
 */
const Tabs: TabsComponent = ({ children, marginBottom = 'small' }) => {
  const tabs = findAllForSlot('Tab', children);
  return (
    <ul className={cx(styles.tabs, {
      [styles.tabsMarginBottomSmall]: marginBottom === 'small',
      [styles.tabsMarginBottomMedium]: marginBottom === 'medium',
      [styles.tabsMarginBottomLarge]: marginBottom === 'large',
    })}>
      {tabs}
    </ul>
  );
};

Tabs.Tab = defineSlotComponent('Tab', Tab);

export { default as useTabs } from './useTabs';

export default Tabs;
